import service from '@/utils/request';

//以下都是旧的接口，可能已经废弃
export var couponList = function couponList(data) {
  return service({
    url: "/coupon/couponList",
    method: 'post',
    data: data
  });
};
export var couponSave = function couponSave(data) {
  return service({
    url: "/coupon/couponSave",
    method: 'post',
    data: data
  });
};
export var couponConfig = function couponConfig(data) {
  return service({
    url: "/coupon/couponConfig",
    method: 'post',
    data: data
  });
};
export var couponDetail = function couponDetail(data) {
  return service({
    url: "/coupon/couponDetail",
    method: 'post',
    data: data
  });
};
export var inputCouponCode = function inputCouponCode(data) {
  return service({
    url: "/coupon/inputCouponCode",
    method: 'post',
    data: data
  });
};
export var couponApp = function couponApp(couponType) {
  return service({
    url: "/coupon/couponApp",
    method: 'post',
    data: {
      coupon_type: couponType
    }
  });
};
export var couponAppSave = function couponAppSave(data) {
  return service({
    url: "/coupon/couponAppSave",
    method: 'post',
    data: data
  });
};